import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/icon-menu-blue.svg'
import _imports_1 from '../assets/icon-menu-blue2.svg'
import _imports_2 from '../assets/logo.png'


const _hoisted_1 = {
  key: 0,
  src: _imports_0,
  class: "text-yellow-300"
}
const _hoisted_2 = {
  key: 1,
  src: _imports_1
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "mb-6 h-28 w-28 ml-14"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-blue-secondary dark:text-pink-primary cursor-pointer hover:dark:text-blue-primary hover:text-pink-primary" }, "Home", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-blue-secondary dark:text-pink-primary mt-3 cursor-pointer hover:dark:text-blue-primary hover:text-pink-primary" }, "Order History", -1)

import Sidebar from 'primevue/sidebar';
import { shallowRef } from 'vue';
import {useDark} from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'SideBarComponent',
  setup(__props) {

const isDark = useDark()
const visibleLeft = shallowRef(false);


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "cursor-pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (visibleLeft.value=true))
    }, [
      (_unref(isDark)==true)
        ? (_openBlock(), _createElementBlock("img", _hoisted_1))
        : _createCommentVNode("", true),
      (_unref(isDark)==false)
        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Sidebar), {
      visible: _unref(visibleLeft),
      "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (_isRef(visibleLeft) ? (visibleLeft).value = $event : null)),
      baseZIndex: 10000,
      class: "dark:bg-[#121212]"
    }, {
      default: _withCtx(() => [
        _hoisted_3,
        _createVNode(_component_router_link, {
          to: "/",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (visibleLeft.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/history",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (visibleLeft.value=false))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})